/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow

import React from 'react';
import { Icon } from '@shopify/polaris';
import {
  HeaderMajor,
  // PriceLookupMinor,
  SectionMajor,
  ListMajor,
  HorizontalDotsMinor,
  ImageMajor,
  TextBlockMajor,
  // SearchMinor,
  TextAlignmentCenterMajor,
  TextAlignmentLeftMajor,
  TextAlignmentRightMajor,
  CheckoutMajor,
  // EmbedMinor,
  CollectionsMajor
} from '@shopify/polaris-icons';
import { ReactComponent as QuickView } from 'src/assets/images/common/quick-view.svg';
import { ReactComponent as TopArea } from 'src/assets/images/common/top.svg';
import { ReactComponent as MiddleArea } from 'src/assets/images/common/middle.svg';
import { ReactComponent as BottomArea } from 'src/assets/images/common/bottom.svg';
import { ReactComponent as LeftAlignment } from 'src/assets/images/common/left.svg';
import { ReactComponent as RightAlignment } from 'src/assets/images/common/right.svg';
import { ReactComponent as Bold } from 'src/assets/images/styles/bold.svg';
import { ReactComponent as Italic } from 'src/assets/images/styles/italic.svg';
import { ReactComponent as Underline } from 'src/assets/images/styles/underline.svg';
import Popupcart from 'src/assets/images/quick-view-cart/tooltip/Cart display_Popupcart.gif';
import Sidecart from 'src/assets/images/quick-view-cart/tooltip/Cart display_Sidecart.gif';
import { ReactComponent as TopLeftAlignment } from 'src/assets/images/common/top-left.svg';
import { ReactComponent as BottomRightAlignment } from 'src/assets/images/common/bottom-right.svg';
import { ReactComponent as BottomCenterAlignment } from 'src/assets/images/common/bottom-center.svg';
import { ReactComponent as BottomLeftAlignment } from 'src/assets/images/common/bottom-left.svg';
import { ReactComponent as TopRightAlignment } from 'src/assets/images/common/top-right.svg';
import { ReactComponent as MiddleLeftAlignment } from 'src/assets/images/common/middle-left.svg';
import { ReactComponent as CentralAlignment } from 'src/assets/images/common/central.svg';
import { ReactComponent as MiddleRightAlignment } from 'src/assets/images/common/middle-right.svg';
import { ReactComponent as TopCenterAlignment } from 'src/assets/images/common/top-center.svg';
import { ReactComponent as IconRectangle } from 'src/assets/images/shopify-integration-settings/rectangle.svg';
import { ReactComponent as IconRoundedRectangle } from 'src/assets/images/shopify-integration-settings/rounded-rectangle.svg';
import { ReactComponent as IconCapsule } from 'src/assets/images/shopify-integration-settings/capsule.svg';
import { ReactComponent as IconCircle } from 'src/assets/images/shopify-integration-settings/circle.svg';
import { ReactComponent as IconSquare } from 'src/assets/images/shopify-integration-settings/square.svg';
import { ReactComponent as IconButtonRectangle } from 'src/assets/images/shopify-integration-settings/btn-rectangle.svg';
import { ReactComponent as IconButtonRoundedRectangle } from 'src/assets/images/shopify-integration-settings/btn-rounded-rectangle.svg';
import { ReactComponent as IconButtonCapsule } from 'src/assets/images/shopify-integration-settings/btn-capsule.svg';
import Layout1 from 'src/assets/images/shopify-integration-settings/layout-1-option.png';
import Layout2 from 'src/assets/images/shopify-integration-settings/layout-2-option.png';

import {
  PRODUCT_IMAGE_ELEMENTS_OPTIONS,
  PRODUCT_INFORMATION_ELEMENTS,
  COLLECTION_HEADER_ELEMENTS,
  TOOLBAR_ELEMENTS,
  LABEL_SHAPE_VALUE,
  SHAPE_VALUE,
  BUTTON_SHAPE_VALUE,
  SUB_LAYOUT_VALUE
} from 'src/constants/theme-settings';

export const MENU_ID = {
  COLLECTION_HEADER: 'collectionHeader_setting',
  IN_COLLECTION_SEARCH: 'inCollectionSearch_setting',
  SEARCH_HEADER: 'searchHeader_setting',
  SEARCH_RESULT: 'searchResult_setting',
  TOOLBAR: 'toolbar_setting',
  PRODUCT_LIST: 'productList_setting',
  PAGINATION: 'pagination_setting',
  PRODUCT_ITEM: 'productItem_setting',
  PRODUCT_IMAGE: 'productImage_setting',
  PRODUCT_IMAGE_TOP: 'productImageTop_setting',
  PRODUCT_IMAGE_MIDDLE: 'productImageMiddle_setting',
  PRODUCT_IMAGE_BOTTOM: 'productImageBottom_setting',
  PRODUCT_INFORMATION: 'productInformation_setting',
  QUICK_VIEW: 'quickView_setting',
  AJAX_CART: 'cart_setting',
  CUSTOM_CSS: 'customCss_setting',
  PRODUCT_LABEL: 'productLabel',
  SWATCHES: 'swatches'
};

export const MENU_SETTING_COLLECTION = [
  {
    id: MENU_ID.COLLECTION_HEADER,
    title: 'AdminHTML.ThemeSetting.Setting.collection_CollectionHeader',
    icon: <Icon source={HeaderMajor} color="base" />,
    children: [],
    isCollapsible: true,
    isAddable: true,
    isBorder: false,
    elements: COLLECTION_HEADER_ELEMENTS,
    isAllowHide: true,
    isHidden: false,
    notDragDrop: true
  }
  // {
  //   id: MENU_ID.IN_COLLECTION_SEARCH,
  //   title: 'AdminHTML.ThemeSetting.Setting.collection_InCollectionSearch',
  //   icon: <Icon source={SearchMinor} color="base" />,
  //   children: [],
  //   isCollapsible: false,
  //   isAddable: false,
  //   isBorder: true,
  //   isAllowHide: true,
  //   isHidden: false
  // }
];

export const MENU_SETTING_SEARCH = [
  {
    id: MENU_ID.SEARCH_HEADER,
    title: 'AdminHTML.ThemeSetting.Setting.search_SearchHeader',
    icon: <Icon source={HeaderMajor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: false,
    isAllowHide: false,
    isHidden: false,
    notDragDrop: true
  }
  // {
  //   id: MENU_ID.SEARCH_RESULT,
  //   title: 'AdminHTML.ThemeSetting.Setting.search_SearchResult',
  //   icon: <Icon source={PriceLookupMinor} color="base" />,
  //   children: [],
  //   isCollapsible: false,
  //   isAddable: false,
  //   isBorder: true,
  //   isAllowHide: true,
  //   isHidden: false
  // }
];

export const MENU_SETTING_COMMON = [
  {
    id: MENU_ID.TOOLBAR,
    title: 'AdminHTML.ThemeSetting.Setting.general_Toolbar',
    icon: <Icon source={SectionMajor} color="base" />,
    children: [],
    isCollapsible: true,
    isAddable: true,
    isBorder: false,
    elements: TOOLBAR_ELEMENTS
  },
  {
    id: MENU_ID.PRODUCT_LIST,
    title: 'AdminHTML.ThemeSetting.Setting.general_ListOfProduct',
    icon: <Icon source={ListMajor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: false
  },
  {
    id: MENU_ID.PAGINATION,
    title: 'AdminHTML.ThemeSetting.Setting.general_Pagination',
    icon: <Icon source={HorizontalDotsMinor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: true
  },
  {
    id: MENU_ID.PRODUCT_ITEM,
    title: 'AdminHTML.ThemeSetting.Setting.productItem',
    isCollapsible: true,
    isBorder: true,
    icon: <Icon source={CollectionsMajor} color="base" />,
    subMenu: [
      {
        id: MENU_ID.PRODUCT_IMAGE,
        title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage',
        icon: <Icon source={ImageMajor} color="base" />,
        children: [
          {
            id: MENU_ID.PRODUCT_IMAGE_TOP,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_TopArea',
            icon: (
              <span className="Polaris-Icon">
                <TopArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          },
          {
            id: MENU_ID.PRODUCT_IMAGE_MIDDLE,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_MiddleArea',
            icon: (
              <span className="Polaris-Icon">
                <MiddleArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          },
          {
            id: MENU_ID.PRODUCT_IMAGE_BOTTOM,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_BottomArea',
            icon: (
              <span className="Polaris-Icon">
                <BottomArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          }
        ],
        isCollapsible: true,
        isAddable: false,
        isBorder: false,
        isHasAreaChildren: true,
        elements: PRODUCT_IMAGE_ELEMENTS_OPTIONS
      },
      {
        id: MENU_ID.PRODUCT_INFORMATION,
        title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductInformation',
        icon: <Icon source={TextBlockMajor} color="base" />,
        children: [],
        isCollapsible: true,
        isAddable: true,
        isBorder: true,
        elements: PRODUCT_INFORMATION_ELEMENTS
      }
    ]
  },
  {
    id: MENU_ID.QUICK_VIEW,
    title: 'AdminHTML.ThemeSetting.Setting.quickView',
    children: [],
    isBorder: true,
    icon: (
      <span className="Polaris-Icon">
        <QuickView className="Polaris-Icon__Svg" />
      </span>
    )
  },
  {
    id: MENU_ID.AJAX_CART,
    title: 'AdminHTML.ThemeSetting.Setting.cartSetting',
    children: [],
    isBorder: true,
    icon: <Icon source={CheckoutMajor} color="base" />
  }
  // {
  //   id: MENU_ID.CUSTOM_CSS,
  //   title: 'AdminHTML.ThemeSetting.Setting.customCss',
  //   children: [],
  //   isBorder: true,
  //   icon: <Icon source={EmbedMinor} color="base" />
  // }
];

export const ALIGNMENT_VALUE = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const PRODUCT_INFORMATION_ALIGNMENT_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];
export const PRODUCT_INFORMATION_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const SWATCH_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const SWATCH_SHAPE_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <IconSquare className="Polaris-Icon__Svg" />
      </span>
    ),
    value: SHAPE_VALUE.SQUARE
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: SHAPE_VALUE.CIRCLE
  }
];

export const LABEL_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const AJAX_CART_DISPLAY_TYPES = [
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item1',
    value: 'side',
    tooltipImage: Sidecart
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item2',
    value: 'popup',
    tooltipImage: Popupcart
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item3',
    value: 'none',
    tooltipText: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item3_Tooltip'
  }
];

export const AJAX_CART_DISPLAY_TYPES_V2 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item1',
    value: 'side',
    tooltipImage: Sidecart
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item2',
    value: 'popup',
    tooltipImage: Popupcart
  }
];

export const FONT_STYLE_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <Bold className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'bold'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <Italic className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'italic'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <Underline className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'underline'
  }
];

export const PRODUCT_RATING_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const TEXT_ALIGNMENT_OPTIONS = [
  {
    label: <Icon source={TextAlignmentLeftMajor} color="base" />,
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: <Icon source={TextAlignmentCenterMajor} color="base" />,
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: <Icon source={TextAlignmentRightMajor} color="base" />,
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const POSITION_VALUE = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  MIDDLE_LEFT: 'middle-left',
  MIDDLE_CENTER: 'middle-center',
  MIDDLE_RIGHT: 'middle-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right'
};
export const POSITION_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <TopLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <TopCenterAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <TopRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_RIGHT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_RIGHT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomCenterAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_RIGHT
  }
];

export const BUTTON_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const BUTTON_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',

    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const BUTTON_SHAPE_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.RECTANGLE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonRoundedRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.ROUNDED_RECTANGLE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonCapsule className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.CAPSULE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.CIRCLE
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconSquare className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.SQUARE
  }
];

export const BREADCRUMB_ALIGNMENT_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-left'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-center'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-right'
  }
];

export const BREADCRUMB_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: 'middle-left'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: 'middle-center'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: 'middle-right'
  }
];

export const PAGINATION_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];
export const PAGINATION_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const LABEL_SHAPE_OPTIONS = [
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip1',
    icon: (
      <span className="Polaris-Icon">
        <IconRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.RECTANGLE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip2',
    icon: (
      <span className="Polaris-Icon">
        <IconRoundedRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.ROUNDED_RECTANGLE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip3',
    icon: (
      <span className="Polaris-Icon">
        <IconCapsule className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.CAPSULE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip4',
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.CIRCLE
  }
];

export const SUB_LAYOUT_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout1',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_2,
    sample: Layout1
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout2',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_2,
    sample: Layout2
  }
];
